import React from "react";
import "./Inner.css";

const flowSteps = [
  "Professional Hearing Assessment",
  "Hearing Aid Recommendation",
  "Eligibility Assessment",
  "Flexible Payment Approval",
  "Receive Your Hearing Aid",
];

const faqs = [
  {
    q: "Do I need a hearing test before getting a hearing aid?",
    a: "Yes. Every hearing aid should be recommended following a professional hearing assessment.",
  },
  {
    q: "Can I buy a hearing aid without seeing an audiologist?",
    a: "We strongly recommend a professional assessment to ensure the right device is selected and programmed for your hearing needs.",
  },
  {
    q: "How does financing work?",
    a: "If a hearing aid is recommended, eligible patients may qualify for flexible payment options through our financing partner.",
  },
  {
    q: "Is financing guaranteed?",
    a: "No. All financing applications are subject to eligibility assessment and approval.",
  },
  {
    q: "Do you provide follow-up care?",
    a: "Yes. HearMenders supports you before, during and after your hearing aid fitting.",
  },
];

export default function Financing() {
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <span className="eyebrow" style={{ color: "#F2FAFA" }}>Hearing Aid Financing</span>
          <h1>Better Hearing Shouldn't Be Out of Reach</h1>
        </div>
      </section>

      <section>
        <div className="container narrow">
          <p>
            Many people delay hearing treatment because of the cost. Through HearMenders,
            eligible patients can access hearing aids through flexible payment arrangements.
          </p>

          <h2>How It Works</h2>
          <div className="flow">
            {flowSteps.map((s, i) => (
              <React.Fragment key={s}>
                <div className="flow-step">{s}</div>
                {i < flowSteps.length - 1 && <span className="flow-arrow">↓</span>}
              </React.Fragment>
            ))}
          </div>

          <div className="notice">
            <strong>Important Notice:</strong> Financing is available only after a professional
            hearing assessment and is subject to eligibility assessment and approval by our
            financing partner.
          </div>
        </div>
      </section>

      <section className="split-band" id="faq">
        <div className="container narrow">
          <h2>Frequently Asked Questions</h2>
          {faqs.map((f) => (
            <div className="faq-item" key={f.q}>
              <h3>{f.q}</h3>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
